import gql from 'graphql-tag'

/**
 * All the channel fields required for the <ChannelTile> component to work
 */
export const channelTileFields = gql`
  fragment ChannelTileFields on Channel {
    id
    name
    shortName
    localisation
    nbAlarms
    criticalities
    colors @client
    winkingAlarm {
      id
      toBeAcknowledged
    }
    lastMeasure {
      date
      value
    }
    acqChain {
      id
      name
      unit {
        id
        symbol
      }
    }
  }
`
